import { Product } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const productsApi = createApi({
  reducerPath: 'productsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getProductByCode: builder.query<Product, string>({
      query: (code) => `products/code/${code}`,
      keepUnusedDataFor: 60 * 60 * 24, // Cache for 24 hours
    }),
  }),
});

export const CONSULTATION_PRODUCT_CODE = 'intro_call_consultation';

export const { useGetProductByCodeQuery } = productsApi;
